import { UISchema } from '@/type';
import { MaterialEditorConfig, TextureSlotSelect } from '../type';

export function getBasicMaterialSchema(config: MaterialEditorConfig): UISchema {
  return [
    {
      uiType: 'InputText',
      fieldName: 'type',
      label: '材质类型',
      disabled: true,
    },
    {
      uiType: 'Select',
      fieldName: 'textureSlots.map.value',
      label: '贴图',
      options: (config.textureSlots.map as TextureSlotSelect).options,
      allowClear: true,
    },
    {
      uiType: 'ColorPicker',
      fieldName: 'color',
      label: '颜色',
      type: ['pure'],
    },
    {
      uiType: 'CheckBox',
      fieldName: 'transparent',
      label: '透明',
    },
    {
      uiType: 'Select',
      fieldName: 'textureSlots.alphaMap.value',
      label: '透明贴图',
      options: (config.textureSlots.alphaMap as TextureSlotSelect).options,
      allowClear: true,
    },
    {
      uiType: 'InputSlider',
      fieldName: 'opacity',
      label: '不透明度',
      min: 0,
      max: 1,
    },
    {
      uiType: 'Select',
      fieldName: 'textureSlots.aoMap.value',
      label: 'AO贴图',
      options: (config.textureSlots.aoMap as TextureSlotSelect).options,
      allowClear: true,
    },
    {
      uiType: 'InputSlider',
      fieldName: 'aoMapIntensity',
      label: 'AO强度',
      min: 0,
      max: 1,
    },
    {
      uiType: 'InputSlider',
      fieldName: 'alphaTest',
      label: '透明阈值',
      min: 0,
      max: 1,
      tooltip:
        '通过对 Alpha 值进行比较操作（如GREATER）剔除低透明度的像素，用于处理具有透明区域的纹理，例如树叶、栅格等复杂模型。',
    },
    {
      uiType: 'CheckBox',
      fieldName: 'alphaToCoverage',
      label: '透明多采样',
      tooltip:
        '应用多重采样抗锯齿（MSAA）技术以提高透明材质边缘的渲染质量，特别适合透明度渐变的场景。',
    },
    {
      uiType: 'Select',
      fieldName: 'side',
      label: '渲染面',
      options: [
        {
          key: 0,
          label: '正面',
        },
        {
          key: 1,
          label: '背面',
        },
        {
          key: 2,
          label: '双面',
        },
      ],
      tooltip:
        '确定渲染的几何面向（正面、背面或双面），与三角形法线方向和裁剪面剔除机制（Culling）紧密相关，影响渲染效率和视觉效果。',
    },
    {
      uiType: 'CheckBox',
      fieldName: 'depthWrite',
      label: '深度写入',
      tooltip:
        '控制渲染对象是否将其深度值写入深度缓冲区，用于定义遮挡关系和优化渲染性能，通常在处理不透明物体时启用。',
    },
    {
      uiType: 'CheckBox',
      fieldName: 'depthTest',
      label: '深度测试',
      tooltip:
        '基于像素深度值与深度缓冲区的比较结果（如LESS、EQUAL），决定当前像素是否被渲染，用于实现正确的前后遮挡效果。',
    },
    {
      uiType: 'CheckBox',
      fieldName: 'fog',
      label: '雾效',
    },
  ];
}
